import React from 'react'

export default function IconText({
  icon,
  text,
  textClassName,
}: {
  icon: React.ReactNode
  text: string
  textClassName?: string
}) {
  return (
    <div
      className={`body-text-4 ${
        textClassName || 'grey-70'
      } mb-xs d-flex align-items-center`}
    >
      <span className="mr-xs" style={{ width: '16px' }} aria-hidden="true">
        {icon}
      </span>
      {text}
    </div>
  )
}
